import React from 'react'

interface FormGridProps {
 children: React.ReactNode
 columns?: 1 | 2 | 3 | 4
 className?: string
}

const gridCols = {
 1: 'grid-cols-1',
 2: 'grid-cols-1 md:grid-cols-2',
 3: 'grid-cols-1 md:grid-cols-3',
 4: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4'
}

export const FormGrid: React.FC<FormGridProps> = ({
 children,
 columns = 2,
 className = ''
}) => {
 return (
 <div className={`grid ${gridCols[columns]} gap-4 ${className}`}>
 {children}
 </div>
 )
}

